// Mock data for EEBS clone

export const navItems = [
  {
    label: "Why EEBS?",
    href: "#why",
    children: [
      { label: "Our Story", href: "#story" },
      { label: "Testimonials", href: "#testimonials" },
      { label: "HMRC Record", href: "#hmrc" },
    ],
  },
  {
    label: "Solutions Provided",
    href: "#solutions",
    children: [
      { label: "CIS Payroll", href: "#cis" },
      { label: "Compliance", href: "#compliance" },
      { label: "Worker Status", href: "#worker-status" },
    ],
  },
  {
    label: "About",
    href: "#about",
    children: [
      { label: "About Us", href: "#about-us" },
      { label: "Team", href: "#team" },
      { label: "Careers", href: "#careers" },
    ],
  },
  { label: "Contact Us", href: "#contact" },
];

export const stats = [
  {
    value: "23+",
    label: "years supporting the construction workforce.",
    variant: "light",
  },
  {
    value: "100%",
    label: "HMRC pass rate: over 50 inspections \u2013 never challenged.",
    variant: "yellow",
  },
  {
    value: "1/2 million",
    suffix: "and counting...",
    label: "Half a million timesheets processed",
    variant: "teal",
  },
];

export const services = [
  {
    icon: "Users",
    title: "CIS Payroll",
    description:
      "We handle your CIS payroll end-to-end, from calculating deductions to submitting monthly returns to HMRC. Accurate, on time, every time.",
  },
  {
    icon: "ShieldCheck",
    title: "Compliance",
    description:
      "Stay compliant with ever-changing HMRC regulations. We monitor, verify, and manage your compliance so you never have to worry about penalties.",
  },
  {
    icon: "HardHat",
    title: "Worker Status",
    description:
      "Determine the correct employment status for your workers. We ensure you're operating within the law and protecting your business from risk.",
  },
];

export const articles = [
  {
    title: "Protect Your Business From HMRC, IR35 & Employment Rights Claims",
    image:
      "https://images.unsplash.com/photo-1672748341520-6a839e6c05bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJ8ZW58MHx8fHwxNzc2OTc3NjUyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Understanding CIS Exemptions in Payroll",
    image:
      "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJ8ZW58MHx8fHwxNzc2OTc3NjUyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "CIS Payroll - Quick Fire Questions",
    image:
      "https://images.pexels.com/photos/31983878/pexels-photo-31983878.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "As a building contractor why do I need EEBS?",
    image:
      "https://images.pexels.com/photos/21619174/pexels-photo-21619174.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "What's the week to week payment process?",
    image:
      "https://images.unsplash.com/photo-1759922378219-1d31edb644f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxoYXJkJTIwaGF0JTIwYnVpbGRlcnN8ZW58MHx8fHwxNzc2OTc3NjU3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "What is IR35? And can EEBS protect my business?",
    image:
      "https://images.unsplash.com/photo-1623489254637-a2dd8375243d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxoYXJkJTIwaGF0JTIwYnVpbGRlcnN8ZW58MHx8fHwxNzc2OTc3NjU3fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const footerLinks = [
  { label: "Why EEBS?", href: "#why" },
  { label: "Solutions Provided", href: "#solutions" },
  { label: "About Us", href: "#about" },
  { label: "Resource Hub", href: "#resources" },
  { label: "Contact Us", href: "#contact" },
];

export const bottomLinks = [
  "Terms of Use",
  "Modern Slavery Act",
  "2010 Bribery Act",
  "Privacy Policy",
  "GDPR Policy",
  "Acceptable Use Policy",
  "Cookie Policy",
  "Right to Work Policy",
];

export const heroImage =
  "https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJ8ZW58MHx8fHwxNzc2OTc3NjUyfDA&ixlib=rb-4.1.0&q=85";

export const contactImage =
  "https://images.unsplash.com/photo-1775880303572-791fbbb73d32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxoYXJkJTIwaGF0JTIwYnVpbGRlcnN8ZW58MHx8fHwxNzc2OTc3NjU3fDA&ixlib=rb-4.1.0&q=85";
